module.exports = __webpack_public_path__ + "img/excelLogo.5f2370d9.png";